<template>
  <div>
    <h2>Lexicon groups list</h2>
    <p class="float-left">
      Manage user lexicon for transcription service. To create a new lexicon,
      click on the "<b>Create new lexicon</b>" button.
    </p>
     <div class="float-right">
      <button
        type="button"
        class="btn btn-warning"
        @click.stop="onCreateNewLexiconGroup($event)"
      >
        <b>Create new lexicon</b>
      </button>
    </div>
    <br />
    <div v-if="this.displayFlash" class="alert alert-success" role="alert" style="width: 30%;">
      ID was copied successfully to clipboard.
    </div>
    <div>
      <grid :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>
    <br /><br />
    <eModal v-model="modal" ref="modal"></eModal>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import { eModal } from 'vue-eagle-modal'
import router from '../router'

export default {
  props: {
    id: {
      type: String
    }
  },
  components: {
    Grid,
    eModal
  },
  data () {
    return {
      displayFlash: false,
      modal: {
        title: 'Create new lexicon',
        theme: 'mojave',
        items: [
          {
            label: 'Description:',
            name: 'desc',
            type: 'text',
            value: '',
            attr: { required: true, autofocus: 'autofocus' }
          }
        ]
      },
      pagination: true,
      search: true,
      cols: [
        {
          name: 'Description',
          formatter: (cell, row) => {
            const linkAction = this.$gridjs.h(
              'span',
              { onClick: () => this.navigateToLexiconWordsList(row.cells[2].data) },
              this.$gridjs.html('<span style="cursor: pointer;"><u>' + cell + '</u></span>')
            )
            return [linkAction]
          }
        },
        {
          name: 'Last Build',
          formatter: (cell) => {
            const linkAction = this.$gridjs.h(
              'span',
              { onClick: () => this.copyToClp(cell) },
              this.$gridjs.html(cell)
            )

            return [linkAction]
          }
        },
        {
          name: 'Actions',
          sort: false,
          formatter: (cell, row) => {
            const deleteAction = this.$gridjs.h(
              'span',
              { onClick: () => this.deleteLexiconGroup(cell) },
              this.$gridjs.html(
                // '<svg style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-x" viewBox="0 0 16 16"><path d="M.54 3.87L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181L15.546 8H14.54l.265-2.91A1 1 0 0 0 13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91H9v1H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zm6.339-1.577A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/><path d="M11.854 10.146a.5.5 0 0 0-.708.708L12.293 12l-1.147 1.146a.5.5 0 0 0 .708.708L13 12.707l1.146 1.147a.5.5 0 0 0 .708-.708L13.707 12l1.147-1.146a.5.5 0 0 0-.708-.708L13 11.293l-1.146-1.147z"/></svg>'
                '<button type="button" class="btn mx-2 mt-1 btn-primary btn-md">Delete</button>'
              )
            )
            const editAction = this.$gridjs.h(
              'span',
              { onClick: () => this.navigateToLexiconEdit(row.cells[2].data) },
              this.$gridjs.html(
                // '<svg style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg>'
              )
            )
            const submitJobAction = this.$gridjs.h(
              'span',
              { onClick: () => this.submitJob(cell) },
              this.$gridjs.html(row.cells[1].data.search('No submitted') !== -1 ? '<span></span>' : '<button type="button" class="btn mx-2 mt-1 btn-primary btn-md">Manage</button>')
            )

            const viewWordsActoin = this.$gridjs.h(
              'span',
              { onClick: () => this.navigateToLexiconWordsList(row.cells[2].data) },
              this.$gridjs.html('<button type="button" class="btn mx-2 mt-1 btn-primary btn-md">View Words</button>')
            )

            return [editAction, viewWordsActoin, submitJobAction, deleteAction]
          }
        }
      ],
      rows: []
    }
  },
  mounted: function () {
    const em = this.$refs.modal.open()
    em.close() // TODO: => The only way to get the const "em" populated with modal object is by opening the moodal, this makes no sense as we directly close it, this will be rewritten using a better modal component.
    em.onsave((m) => {
      m.loading()
      apiClient.post('/api/lexicons/add', {
        desc: m.getItems()[0].value
      }).then((response) => {
        if (response.status === 201) {
          this.rows.push([m.getItems()[0].value, 'No available event for this item yet.', response.data.id])
          m.getItems()[0].value = ''
        }
        m.loaded()
        m.close()
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
        m.loaded()
      })
    })

    apiClient
      .get('/api/lexicons/list')
      .then((response) => {
        const gridComp = this.$children[0]
        response.data.groups.forEach((item, key) => {
          let status = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/></svg>'
          status += ' <font>No submitted builds yet</font>'

          if (item.build_request_date) {
            const currentTime = new Date().getTime()
            const buildTime = Date.parse(item.build_request_date)
            const difference = Math.abs(currentTime - buildTime)
            const duration = difference / (1000 * 3600)

            if (duration >= 24) {
              status = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>'
              status += ' <span style="color: red"><u>Build seems to be corrupted.</u></span>'
            } else {
              status = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle-half" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/></svg>'
              status += ' Build request was submitted at the date of (<font color="orange">' + item.build_request_date + '</font>)'
            }
          }

          if (item.build_lexicon_id) {
            status = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16"><path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/></svg>'
            status += ' Build is ready => <font color="green">' + item.build_lexicon_id + '</font>'
            status += ' <span data-v-6a256646="" title="Copy" class="clickable ml-2"><svg data-v-6a256646="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-subtract b-icon bi" data-clipboard-click-handler="$1"><g data-v-6a256646=""><path d="M4 12v2.5A1.5 1.5 0 0 0 5.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 4H12v6.5a1.5 1.5 0 0 1-1.5 1.5H4z"></path><path fill-rule="evenodd" d="M10.5 1h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-9-1A1.5 1.5 0 0 0 0 1.5v9A1.5 1.5 0 0 0 1.5 12h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 10.5 0h-9z"></path></g></svg></span>'
          }

          gridComp.rows.push([
            item.lexicon_description,
            status,
            item.id
          ])
        })
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
  },
  methods: {
    copyToClp: function (text) {
      text = text.split('<font color="green">')[1].split('</font>')[0]
      console.log(text)
      if (window.clipboardData && window.clipboardData.setData) {
        return window.clipboardData.setData('Text', text)
      } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea')
        textarea.textContent = text
        textarea.style.position = 'fixed'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          return document.execCommand('copy')
        } catch (ex) {
          console.warn('Copy to clipboard failed.', ex)
          return false
        } finally {
          document.body.removeChild(textarea)
          this.displayFlash = true
          setTimeout(() => {
            this.displayFlash = false
          }, 2000)
        }
      }
    },
    navigateToLexiconWordsList: function (id) {
      router.push({ name: 'LexiconWords', params: { id: id } })
    },
    navigateToLexiconEdit: function (id, desc) {
      router.push({ name: 'LexiconEdit', params: { id: id } })
    },
    submitJob: function (id) {
      router.push({ name: 'LexiconBuildsManagement', params: { id: id } })
    },
    addLexiconGroup: function () {
    },
    deleteLexiconGroup: function (id) {
      this.$confirm({
        message: 'Are you sure?',
        button: {
          no: 'No',
          yes: 'Yes, Delete.'
        },
        callback: (confirm) => {
          if (confirm) {
            apiClient.put('/api/lexicons/delete', {
              id: id
            }).then((response) => {
              if (response.status === 204) {
                const gridComp = this.$children[0]
                gridComp.rows.forEach((value, index) => {
                  if (value[2] === id) {
                    gridComp.rows.splice(index, 1)
                  }
                })
              }
            }).catch((error) => {
              if (error.response) {
                console.log(error.response.data)
              }
            })
          }
        }
      })
    },
    onCreateNewLexiconGroup: function (e) {
      e.preventDefault()
      document.activeElement.blur()
      this.$data.em = this.$refs.modal.open()
    }
  },
  computed: {
    hasData () {
      return this.rows.length > 0
    }
  }
}
</script>
